var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTickImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 64 64",
    width: "64px",
    height: "64px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface271442217"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(34.509805%,38.039216%,68.235296%)",
      fillOpacity: 1
    },
    d: "M 51.25 11.238281 C 52.898438 12.304688 53.371094 14.507812 52.304688 16.15625 L 29.265625 51.710938 C 28.660156 52.644531 27.652344 53.242188 26.542969 53.324219 C 26.457031 53.332031 26.367188 53.332031 26.28125 53.332031 C 25.265625 53.332031 24.289062 52.898438 23.613281 52.125 L 12.011719 38.941406 C 10.714844 37.464844 10.859375 35.21875 12.332031 33.921875 C 13.808594 32.625 16.054688 32.769531 17.351562 34.242188 L 25.851562 43.902344 L 46.335938 12.289062 C 47.402344 10.640625 49.605469 10.171875 51.25 11.238281 Z M 51.25 11.238281 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickImage);
export default __webpack_public_path__ + "static/media/tickImage.19afe5e4b8129f587d47f12a531e44f4.svg";
export { ForwardRef as ReactComponent };